import { render, staticRenderFns } from "./PAYGUsageCard.vue?vue&type=template&id=a3bc8f74&"
import script from "./PAYGUsageCard.vue?vue&type=script&lang=js&"
export * from "./PAYGUsageCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports